import * as tabs from "./tabs";
import * as sections from "./sections";

tabs.switch_to_queried_tab();
tabs.add_tab_listeners();
sections.init();
